import { render, staticRenderFns } from "./TagFilters.vue?vue&type=template&id=0022f654&scoped=true&"
import script from "./TagFilters.vue?vue&type=script&lang=js&"
export * from "./TagFilters.vue?vue&type=script&lang=js&"
import style0 from "./TagFilters.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TagFilters.vue?vue&type=style&index=1&id=0022f654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022f654",
  null
  
)

export default component.exports